export default class ItemSelector {
  constructor({
    callbacks, checkItemClass = '.check-item', checkAllClass = '.checkall', itemIdDataAttr = 'item-id',
  }) {
    this.checkItemClass = checkItemClass;
    this.checkAllClass = checkAllClass;
    this.itemIdDataAttr = itemIdDataAttr;
    this.callbacks = callbacks;
    this.setup();
  }

  setup() {
    const self = this;

    $(self.checkItemClass).on('click', (event) => {
      event.stopPropagation();
      self.updateCheckAll();
    });

    $(self.checkAllClass).on('click', function handleCheckAllClick(event) {
      const checked = $(this).is(':checked');

      $(self.checkItemClass).each(function applyCheckedState(index) {
        $(this).prop('checked', checked);
      });
      self.updateItemIds();
    });
  }

  updateItemIds() {
    const self = this;
    const itemIds = [];
    const $checkedItems = $(`${self.checkItemClass}:checked`);
    $checkedItems.each(function collectItemId(index) {
      const itemId = $(this).data(self.itemIdDataAttr);
      itemIds.push(itemId);
    });
    self.callCallbacks(itemIds);
  }

  callCallbacks(itemIds) {
    for (const callback of this.callbacks) {
      callback(itemIds);
    }
  }

  updateCheckAll() {
    const self = this;

    const $checkboxes = $(this.checkItemClass);
    const $checkall = $(this.checkAllClass);

    const checkedCount = $(`${self.checkItemClass}:checked`).length;
    $checkall.prop('checked', (checkedCount > 0));
    const indeterminate = checkedCount > 0 && checkedCount < $checkboxes.length;
    $checkall.prop('indeterminate', indeterminate);
    this.updateItemIds();
  }
}
